<template>
  <div class="flex flex-wrap pill-container pill-container--full hide-small">
    <div v-for="item in combinedAttributes" :key="item.Group" class="form-group form-group--checkbox pill-box">
      <button type="button" @click="removeItem(item)" class="type-small pill">
        <span class="type-capital" v-if="item.Group && ['total', 'Men', 'Women'].includes(item.Group)">{{ tagLabel(item)
        }}</span>
        {{ item.Name }}
        <img class="pill__close" src="/images/icon-close-thick-gold.svg" alt="pill-close">
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { GET_FILTERED_ITEMS, SET_CATALOG_LOCALSTORAGE } from '../vuex/modules/catalog/mutations';

export default {
  name: 'CatalogActiveFilters',
  methods: {
    ...mapActions({
      GET_FILTERED_ITEMS,
      SET_CATALOG_LOCALSTORAGE,
    }),
    // on click, this method is fired to remove this item
    // from the state array of active filters
    removeItem(attribute) {
      const updates = () => new Promise((resolve) => {
        if (attribute.hasOwnProperty('Group')) {
          this.$store.commit('clearActiveCastSize', attribute);
        } else {
          this.$store.commit('setActiveAttributes', attribute);
        }

        this.$store.commit('setPageNumber', 1);

        resolve();
      });

      updates()
        .then(() => this.GET_FILTERED_ITEMS())
        .then(() => this.SET_CATALOG_LOCALSTORAGE());
    },
    tagLabel(item) {
      return ['total', 'Men', 'Women'].includes(item.Group) ? '' : `${item.Group}: `;
    },
  },
  computed: {
    ...mapState({
      activeAttributes: state => state.catalogStore.activeAttributes,
      activeCastSize: state => state.catalogStore.activeCastSize,
    }),
    combinedAttributes() {
      return this.activeAttributes.concat(this.activeCastSize);
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CatalogActiveFilters.vue